import api from './api';

// Employee endpoints
export const fetchEmployees = async (params = {}) => {
  const response = await api.get('/admin/employees/employees/', { params });
  return response.data;
};

export const getEmployee = async (id) => {
  const response = await api.get(`/admin/employees/employees/${id}/`);
  return response.data;
};

export const createEmployee = async (data) => {
  const response = await api.post('/admin/employees/employees/', data);
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const response = await api.put(`/admin/employees/employees/${id}/`, data);
  return response.data;
};

export const patchEmployee = async (id, data) => {
  const response = await api.patch(`/admin/employees/employees/${id}/`, data);
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await api.delete(`/admin/employees/employees/${id}/`);
  return response.data;
};

export const getEmployeeHistory = async (id) => {
  const response = await api.get(`/admin/employees/employees/${id}/history/`);
  return response.data;
};

export const terminateEmployee = async (id, data) => {
  const response = await api.post(`/admin/employees/employees/${id}/terminate/`, data);
  return response.data;
};

// Department endpoints
export const fetchDepartments = async (params = {}) => {
  const response = await api.get('/admin/employees/departments/', { params });
  return response.data;
};

export const getDepartment = async (id) => {
  const response = await api.get(`/admin/employees/departments/${id}/`);
  return response.data;
};

export const createDepartment = async (data) => {
  const response = await api.post('/admin/employees/departments/', data);
  return response.data;
};

export const updateDepartment = async (id, data) => {
  const response = await api.put(`/admin/employees/departments/${id}/`, data);
  return response.data;
};

export const deleteDepartment = async (id) => {
  const response = await api.delete(`/admin/employees/departments/${id}/`);
  return response.data;
};

export const getDepartmentEmployees = async (id) => {
  const response = await api.get(`/admin/employees/departments/${id}/employees/`);
  return response.data;
};

// Position endpoints
export const fetchPositions = async (params = {}) => {
  const response = await api.get('/admin/employees/positions/', { params });
  return response.data;
};

export const getPosition = async (id) => {
  const response = await api.get(`/admin/employees/positions/${id}/`);
  return response.data;
};

export const createPosition = async (data) => {
  const response = await api.post('/admin/employees/positions/', data);
  return response.data;
};

export const updatePosition = async (id, data) => {
  const response = await api.put(`/admin/employees/positions/${id}/`, data);
  return response.data;
};

export const deletePosition = async (id) => {
  const response = await api.delete(`/admin/employees/positions/${id}/`);
  return response.data;
};

export const getPositionEmployees = async (id) => {
  const response = await api.get(`/admin/employees/positions/${id}/employees/`);
  return response.data;
};

// Leave Type endpoints
export const fetchLeaveTypes = async (params = {}) => {
  const response = await api.get('/admin/employees/leave-types/', { params });
  return response.data;
};

export const createLeaveType = async (data) => {
  const response = await api.post('/admin/employees/leave-types/', data);
  return response.data;
};

export const updateLeaveType = async (id, data) => {
  const response = await api.put(`/admin/employees/leave-types/${id}/`, data);
  return response.data;
};

// Leave Request endpoints
export const fetchLeaveRequests = async (params = {}) => {
  const response = await api.get('/admin/employees/leave-requests/', { params });
  return response.data;
};

export const getLeaveRequest = async (id) => {
  const response = await api.get(`/admin/employees/leave-requests/${id}/`);
  return response.data;
};

export const createLeaveRequest = async (data) => {
  const response = await api.post('/admin/employees/leave-requests/', data);
  return response.data;
};

export const approveLeaveByManager = async (id) => {
  const response = await api.post(`/admin/employees/leave-requests/${id}/approve-manager/`);
  return response.data;
};

export const approveLeaveByHR = async (id) => {
  const response = await api.post(`/admin/employees/leave-requests/${id}/approve-hr/`);
  return response.data;
};

export const approveLeaveByDirector = async (id) => {
  const response = await api.post(`/admin/employees/leave-requests/${id}/approve-director/`);
  return response.data;
};

export const rejectLeave = async (id, data) => {
  const response = await api.post(`/admin/employees/leave-requests/${id}/reject/`, data);
  return response.data;
};

export const getLeaveCalendar = async (params = {}) => {
  const response = await api.get('/admin/employees/leave-requests/calendar/', { params });
  return response.data;
};

export const getEmployeeLeaveBalance = async (id) => {
  const response = await api.get(`/admin/employees/employees/${id}/leave-balance/`);
  return response.data;
};

// Attendance endpoints
export const fetchAttendance = async (params = {}) => {
  const response = await api.get('/admin/employees/attendance/', { params });
  return response.data;
};

export const fetchAttendanceEmployeesForSubmit = async () => {
  const response = await api.get('/admin/employees/attendance/employees-for-submit/');
  return response.data;
};

export const createAttendance = async (data) => {
  const response = await api.post('/admin/employees/attendance/', data);
  return response.data;
};

export const updateAttendance = async (id, data) => {
  const response = await api.put(`/admin/employees/attendance/${id}/`, data);
  return response.data;
};

export const patchAttendance = async (id, data) => {
  const response = await api.patch(`/admin/employees/attendance/${id}/`, data);
  return response.data;
};

// Document endpoints
export const fetchEmployeeDocuments = async (params = {}) => {
  const response = await api.get('/admin/employees/documents/', { params });
  return response.data;
};

export const createEmployeeDocument = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    if (key === 'file' && data[key] instanceof File) {
      formData.append(key, data[key]);
    } else {
      formData.append(key, data[key]);
    }
  });
  const response = await api.post('/admin/employees/documents/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getEmployeeDocument = async (id) => {
  const response = await api.get(`/admin/employees/documents/${id}/`);
  return response.data;
};

export const updateEmployeeDocument = async (id, data) => {
  const response = await api.patch(`/admin/employees/documents/${id}/`, data);
  return response.data;
};

export const getEmployeeDocuments = async (id) => {
  const response = await api.get(`/admin/employees/employees/${id}/documents/`);
  return response.data;
};

// Dashboard and Reports
export const getEmployeeDashboard = async () => {
  const response = await api.get('/admin/employees/dashboard/');
  return response.data;
};

export const getEmployeeReports = async (params = {}) => {
  const response = await api.get('/admin/employees/reports/', { params });
  return response.data;
};


